//Local
// const baseURL = "http://localhost:4000/api/v1";

//Deployed
const baseURL = "https://genzgames-production-7030.up.railway.app/api/v1";

export { baseURL };
